jQuery(document).ready(function($) {
  if ($('.live-chat--enabled').length > 0) {
    let developmentId = $('.live-chat--enabled').data('development')
    let chatGroup = parseInt($('.live-chat--enabled').data('chat-group'))

    window.__lc = window.__lc || {}
    window.__lc.license = 8045841
    window.__lc.group = chatGroup
    window.__lc.chat_between_groups = false
    ;(function(n, t, c) {
      function i(n) {
        return e._h ? e._h.apply(null, n) : e._q.push(n)
      }
      var e = {
        _q: [],
        _h: null,
        _v: '2.0',
        on: function() {
          i(['on', c.call(arguments)])
        },
        once: function() {
          i(['once', c.call(arguments)])
        },
        off: function() {
          i(['off', c.call(arguments)])
        },
        get: function() {
          if (!e._h)
            throw new Error(
              "[LiveChatWidget] You can't use getters before load."
            )
          return i(['get', c.call(arguments)])
        },
        call: function() {
          i(['call', c.call(arguments)])
        },
        init: function() {
          var n = t.createElement('script')
          ;(n.async = !0),
            (n.type = 'text/javascript'),
            (n.src = 'https://cdn.livechatinc.com/tracking.js'),
            t.head.appendChild(n)
        },
      }
      !n.__lc.asyncInit && e.init(), (n.LiveChatWidget = n.LiveChatWidget || e)
    })(window, document, [].slice)

    $.getScript(
      'https://cdn.jsdelivr.net/npm/@commversion/libs@0/dist/lc-ga-tags.js'
    )

    $.getScript(
      'https://cdn.jsdelivr.net/npm/@commversion/libs@0/dist/lc-exit-intent.js'
    )

    $.getScript(
      'https://cdn.jsdelivr.net/npm/@commversion/libs@0/dist/lc-input-error.js'
    )

    function onChatCustomerStatusChanged(data) {
      let customerData = LiveChatWidget.get('customer_data')
      switch (data.status) {
        case 'queued':
          // customer is in queue
          break
        case 'chatting':
          // customer is currently chatting
          $.event.trigger({
            type: 'harronLiveChatStart',
            customerData: customerData,
            development: developmentId,
            time: new Date(),
          })
          break
        case 'invited':
          // customer received an invitation but didn't start the chat
          break
        case 'browsing':
          // customer is in idle state, not queued, not chatting, and didn't receive an invitation
          break
      }
    }
    LiveChatWidget.on('customer_status_changed', onChatCustomerStatusChanged)
  }

  if ($('.moneypenny-chat--enabled').length > 0) {
    let developmentId = $('.moneypenny-chat--enabled').data('development')
    let regionId = $('.moneypenny-chat--enabled').data('region')

    ;(function() {
      var se = document.createElement('script')
      se.type = 'text/javascript'
      se.async = true
      if (regionId == 20) {
        // North Mids region
        se.src =
          'https://storage.googleapis.com/moneypennychat/js/f38c60dd-1d84-4d27-890d-5be507277928.js'
      } else if (regionId == 21) {
        // Yorkshire region
        se.src =
          'https://storage.googleapis.com/moneypennychat/js/bc2d3070-384d-495e-a106-20bc409d2590.js'
      }
      var done = false
      se.onload = se.onreadystatechange = function() {
        if (
          !done &&
          (!this.readyState ||
            this.readyState === 'loaded' ||
            this.readyState === 'complete')
        ) {
          done = true
          Moneypenny.setCallback('StartChat', function(email, msg, type) {
            // ga('send', 'event', 'Moneypenny', 'startchat', type)
            $.event.trigger({
              type: 'harronMoneypennyChatStart',
              development: developmentId,
              time: new Date(),
            })
          })
          // Moneypenny.setCallback('OpenProactive', function(agent, msg) {
          //   ga('send', 'event', 'Moneypenny', 'proactiveopened', agent)
          // })
          // Moneypenny.setCallback('MessageSubmit', function(email, msg) {
          //   ga('send', 'event', 'Moneypenny', 'offline')
          // })
          // Moneypenny.setCallback('ChatMessageReceived', function(agent, msg) {
          //   ga('send', 'event', 'Moneypenny', 'agentmessage', agent)
          // })
          // Moneypenny.setCallback('ChatMessageSent', function(msg) {
          //   ga('send', 'event', 'Moneypenny', 'visitormessage')
          // })
          // Moneypenny.setCallback('Close', function(agent, status) {
          //   ga('send', 'event', 'Moneypenny', 'closechat')
          // })
          // Moneypenny.setCallback('Open', function(status) {
          //   ga('send', 'event', 'Moneypenny', 'openworks')
          // })
          // Moneypenny.setCallback('Minimize', function(
          //   isMinimized,
          //   chatType,
          //   boxType
          // ) {
          //   ga('send', 'event', 'Moneypenny', 'minimizechat')
          // })
        }
      }
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(se, s)
    })()
  }
})
